import React, {useEffect, useState} from 'react';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";

import {SellerWorkspaceService} from "../../service/SellerWorkspaceService";
import {exportFile} from "../../utils/Utils";

const sellerWorkspaceService = new SellerWorkspaceService();

const exportLabels = (t) => ({
    seller: t('sellers_workspace.export.seller', 'Koçtaş satıcısı'),
    koctas_count: t('sellers_workspace.export.koctasCount', 'Koçtaş ürün'),
    trendyol_store: t('sellers_workspace.export.trendyolStore', 'Trendyol mağazası'),
    trendyol_match: t('sellers_workspace.export.trendyolMatch', 'Trendyol eşleşme'),
    trendyol_count: t('sellers_workspace.export.trendyolCount', 'Trendyol ürün'),
    hepsiburada_store: t('sellers_workspace.export.hepsiburadaStore', 'Hepsiburada mağazası'),
    hepsiburada_match: t('sellers_workspace.export.hepsiburadaMatch', 'Hepsiburada eşleşme'),
    hepsiburada_count: t('sellers_workspace.export.hepsiburadaCount', 'Hepsiburada ürün'),
    month: t('sellers_workspace.export.month', 'Ay'),
    unknown: t('sellers_workspace.unknown', 'bilinmiyor'),
    automatic: t('onboarding.sites.identity.automatic', 'otomatik'),
    confirmed: t('sellers_workspace.export.confirmed', 'onaylı'),
    suggestion: t('onboarding.sites.identity.suggestion', 'öneri'),
    no_match: t('sellers_workspace.detail.noMatch', 'eşleşme yok'),
    not_found: t('sellers_workspace.notFound', 'bulunamadı'),
    official_exact: t('sellers_workspace.official.exact', 'Resmi kayıt eşleşti'),
    official_different: t('sellers_workspace.official.different', 'Resmi kayıt farklı'),
    strength_strong: t('sellers_workspace.export.strengthStrong', 'güçlü'),
    strength_likely: t('sellers_workspace.export.strengthLikely', 'olası'),
    strength_weak: t('sellers_workspace.export.strengthWeak', 'zayıf'),
});

// The monthly delivery: any stored month as Excel. A month nobody ran is simply not offered.
const SellerExport = ({t, onError, reloadKey}) => {
    const [months, setMonths] = useState(null);
    const [month, setMonth] = useState(null);
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        let current = true;
        sellerWorkspaceService.getMonths()
            .then(found => { if (current) { setMonths(found || []); setMonth((found || [])[0] || null); } })
            .catch(() => { if (current) setMonths(null); });
        return () => { current = false; };
    }, [reloadKey]);

    const download = () => {
        setBusy(true);
        sellerWorkspaceService.exportMonth(month, exportLabels(t))
            .then(response => exportFile(response, `saticilar_${month}.xlsx`))
            .catch(onError).finally(() => setBusy(false));
    };

    if (months === null) return null;
    if (!months.length) return <small style={{color: '#6b7280', alignSelf: 'center'}}>{t('sellers_workspace.export.noMonths', 'Henüz sayım yok')}</small>;
    return <span style={{display: 'flex', gap: 8}}>
        <Dropdown value={month} style={{width: '9em'}} options={months.map(item => ({label: item, value: item}))} onChange={(e) => setMonth(e.value)}/>
        <Button label={t('sellers_workspace.export.download', 'Excel indir')} icon="pi pi-file-excel" className="p-button-outlined" loading={busy} onClick={download}/>
    </span>;
};

export default SellerExport;
